import { countFormat, pluralize } from "@src/helpers/constants";
import React from "react";
import { HiOutlineUsers, HiOutlineClipboardCheck } from "react-icons/hi";

interface CountAnalysisCardProps {
  totalWorkers: number;
  cardTitle: string;
  percentage?: any;
  variant?: "total" | "screened";
}

const CountAnalysisCard: React.FC<CountAnalysisCardProps> = ({
  totalWorkers,
  cardTitle,
  percentage,
  variant = "total",
}) => {
  const Icon = variant === "screened" ? HiOutlineClipboardCheck : HiOutlineUsers;
  const hasPct = percentage && Number(percentage) > 0;

  return (
    <div className={`stat-card stat-card--${variant}`}>
      <div className="stat-card-accent" />
      <div className="stat-card-head">
        <div className="stat-card-icon">
          <Icon size={18} />
        </div>
        <span className="stat-card-label">{pluralize(cardTitle)}</span>
        {hasPct && (
          <span className="stat-card-pct">{Number(percentage).toFixed(1)}%</span>
        )}
      </div>
      <div className="stat-card-value">{countFormat(totalWorkers)}</div>
    </div>
  );
};

export default CountAnalysisCard;
